import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class UIBlockerService {

    uiBlocker = new EventEmitter<boolean>();

    blockUI() {
        this.uiBlocker.emit(true);
    }

    unBlockUI() {
        this.uiBlocker.emit(false);
    }

}
